import { TEAM_PRODUCTS_RECEIVED } from '../../actions/product-management/GetTeamProducts';
import { TEAM_PRODUCT_RECEIVED } from '../../actions/product-management/GetTeamProduct';
import { PRODUCT_PUBLISHED } from '../../actions/product-management/PublishProduct';

const initialState = {
  all: [],
};

const products = (state = initialState, action) => {
  switch (action.type) {
    case TEAM_PRODUCTS_RECEIVED:
      return {
        ...state,
        all: action.all,
      };
    case TEAM_PRODUCT_RECEIVED:
      const productIndex = state.all.findIndex(product => product.id === action.product.product.id);

      return Object.assign({}, state, {
        all: productIndex !== -1 ? state.all.splice(productIndex, 1, action.product.product) : state.all.concat(action.product.product),
      });
    case PRODUCT_PUBLISHED:
      const all = state.all.map((product) => {
        if (action.product.product.id == product.id) {
          return action.product.product;
        }

        return product;
      });

      return {
        ...state,
        all,
      };
  }

  return state;
};

export default products;
